import { Box, Image } from '@chakra-ui/react';

import { captchaText } from 'Const/monitoring/view';
import { TextBold, TextRegular } from 'UiKit/typography';
import { CloseIcon } from 'Asset/icon';
import sigliveViolationImage from 'Asset/image/siglive-violation-state.svg';

import styles from './styles.module.css';

const ViolationAttendanceContent = ({ onClose }) => {
  return (
    <Box>
      <Box className={styles['violation__box--header']}>
        <TextBold className={styles['violation__box--header-text']}>{captchaText.violationTitleText}</TextBold>
        <CloseIcon size="24px" color="#333333" onClick={onClose} className={styles['violation__close--icon']} />
      </Box>
      <Box className={styles['violation__image--container']}>
        <Image src={sigliveViolationImage} alt="violation-image" width={'140px'} height={'140px'} />
      </Box>
      <Box className={styles['violation__footer--container']}>
        <TextRegular>{captchaText.violationDescriptionText}</TextRegular>
      </Box>
    </Box>
  );
};

export default ViolationAttendanceContent;
